import { render, staticRenderFns } from "./svg_collectManagement.vue?vue&type=template&id=f5235330"
import script from "./svg_collectManagement.vue?vue&type=script&setup=true&lang=ts"
export * from "./svg_collectManagement.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports